import { Link } from "react-router-dom";
import { useEffect, useRef } from "react";
import siteData from "../data/siteData.json";

function ParkGrandeur() {
  const minDateSetRef = useRef(false);

  useEffect(() => {
    if (minDateSetRef.current) {
      return;
    }
    minDateSetRef.current = true;
    const dateInput = document.getElementById("date");
    if (dateInput) {
      const today = new Date().toISOString().split("T")[0];
      dateInput.setAttribute("min", today);
    }
  }, []);

  const { parkGrandeur } = siteData;

  return (
    <>
      {/* Hero Section */}
      <section className="project-hero">
        <div className="container">
          <div className="project-hero-content">
            <h1>{parkGrandeur.name}</h1>
            <p className="location-tag">
              <i className="fa fa-map-marker"></i> {parkGrandeur.location}
            </p>
            <span className="rera-tag">RERA: {parkGrandeur.rera}</span>
          </div>
        </div>
      </section>

      {/* Quick Stats */}
      <section className="quick-stats">
        <div className="container">
          <div className="row">
            {parkGrandeur.quickStats.map((stat) => (
              <div className="col-md-3 col-6" key={stat.label}>
                <div className="quick-stat-item">
                  <i className={`fa ${stat.icon}`}></i>
                  <h4>{stat.value}</h4>
                  <p>{stat.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Project Overview */}
      <section className="overview-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="overview-image">
                <img
                  src={parkGrandeur.overview.image}
                  alt="Park Grandeaur"
                  className="img-fluid rounded"
                  style={{ boxShadow: "0 15px 40px rgba(0,0,0,0.15)" }}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="overview-content">
                <h2 className="section-title">About Park Grandeur</h2>
                <h3>{parkGrandeur.overview.title}</h3>
                <p>{parkGrandeur.overview.description}</p>
                {parkGrandeur.overview.paras.map((para) => (
                  <p key={para}>{para}</p>
                ))}

                <div className="overview-features">
                  {parkGrandeur.overview.features.map((feature) => (
                    <div className="overview-feature" key={feature}>
                      <i className="fa fa-check-circle"></i>
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Floor Plans */}
      <section className="floor-plans-section">
        <div className="container">
          <h2 className="section-title section-title-center mb-5">Floor Plans</h2>
          <div className="row">
            {parkGrandeur.floorPlans.map((plan) => (
              <div className="col-lg-4 col-md-6 mb-4" key={plan.alt}>
                <div className="floor-plan-card">
                  <div className="floor-plan-image">
                    <img
                      src={plan.image}
                      alt={plan.alt}
                      className="img-fluid"
                    />
                  </div>
                  <div className="floor-plan-info">
                    <h4>{plan.name}</h4>
                    <p className="bhk-type">{plan.bhkType}</p>
                    <div className="floor-plan-details">
                      <div className="floor-plan-detail">
                        <i className="fa fa-th-large"></i>
                        <span>{plan.area}</span>
                      </div>
                      <div className="floor-plan-detail">
                        <i className="fa fa-arrows-alt"></i>
                        <span>Carpet Area</span>
                      </div>
                    </div>
                    <div className="floor-plan-price">
                      {plan.price}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Amenities */}
      <section className="amenities-section">
        <div className="container">
          <h2 className="section-title section-title-center mb-5">World-Class Amenities</h2>
          <div className="row">
            {parkGrandeur.amenities.map((amenity) => (
              <div className="col-md-4 col-sm-6 mb-4" key={amenity.name}>
                <div className="amenity-card">
                  <i className={`fa ${amenity.icon}`}></i>
                  <h5>{amenity.name}</h5>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="gallery-section">
        <div className="container">
          <h2 className="section-title section-title-center mb-5">Project Gallery</h2>
          <div className="row g-4">
            {parkGrandeur.gallery.map((item) => (
              <div className="col-md-4 col-sm-6" key={item.alt}>
                <div className="gallery-item">
                  <img src={item.image} alt={item.alt} />
                  <div className="overlay">
                    <i className="fa fa-search-plus"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Location */}
      <section className="location-section">
        <div className="container">
          <h2 className="section-title section-title-center mb-5">Location Map</h2>
          <div className="location-content">
            <div className="location-map">
              <iframe
                src={parkGrandeur.locationMapEmbed}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Park Grandeur Location"
              ></iframe>
            </div>
            <div className="location-details">
              <h4>Location Advantages</h4>
              <ul>
                {parkGrandeur.locationAdvantages.map((advantage) => (
                  <li key={advantage.title}>
                    <i className={`fa ${advantage.icon}`}></i>
                    <div>
                      <strong>{advantage.title}</strong>
                      <p>{advantage.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Site Visit Booking */}
      <section className="booking-section" id="book-now">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="booking-form-card">
                <div className="booking-form-header">
                  <h3>
                    <i className="fa fa-calendar-check-o"></i> {parkGrandeur.booking.title}
                  </h3>
                  <p>{parkGrandeur.booking.heading}</p>
                </div>
                <div className="booking-form-body">
                  <div className="success-message" id="successMessage">
                    <i className="fa fa-check-circle"></i>
                    <strong>{parkGrandeur.booking.successTitle}</strong>
                    <p>{parkGrandeur.booking.successText}</p>
                  </div>

                  <form className="booking-form" id="siteVisitForm">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="required">Full Name</label>
                          <input type="text" className="form-control" id="name" name="name" placeholder="Enter your full name" required />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="required">Phone Number</label>
                          <input type="tel" className="form-control" id="phone" name="phone" placeholder="Enter your phone number" required />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="required">Email Address</label>
                          <input type="email" className="form-control" id="email" name="email" placeholder="Enter your email" required />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="required">Preferred Date</label>
                          <input type="date" className="form-control" id="date" name="date" required />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="required">Interested Unit</label>
                          <select className="form-control" id="unit" name="unit" required>
                            <option value="">Select Unit Type</option>
                            <option value="3 BHK">3 BHK</option>
                            <option value="4 BHK">4 BHK</option>
                            <option value="4 BHK Luxury">4 BHK Luxury</option>
                            <option value="6 BHK Penthouse">6 BHK Penthouse</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Preferred Time</label>
                          <select className="form-control" id="time" name="time">
                            <option value="">Select Time</option>
                            <option value="10:00 AM">10:00 AM</option>
                            <option value="11:00 AM">11:00 AM</option>
                            <option value="12:00 PM">12:00 PM</option>
                            <option value="2:00 PM">2:00 PM</option>
                            <option value="3:00 PM">3:00 PM</option>
                            <option value="4:00 PM">4:00 PM</option>
                            <option value="5:00 PM">5:00 PM</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Additional Requirements / Questions</label>
                      <textarea className="form-control" id="message" name="message" placeholder="Any specific requirements or questions..."></textarea>
                    </div>

                    <button type="submit" className="btn-book-site-visit">
                      <i className="fa fa-calendar-plus"></i> Schedule Site Visit
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Download Brochure */}
      <section className="download-section">
        <div className="container">
          <div className="download-content">
            <div className="download-text">
              <h3>Download Brochure</h3>
              <p>Get complete project details, floor plans, and pricing in our comprehensive brochure.</p>
            </div>
            <a href="/pdf/Brochure.pdf" target="_blank" className="btn-download-brochure">
              <i className="fa fa-download"></i> Download Brochure
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default ParkGrandeur;